import { CallStateEnum } from "../../models";
import { IMedia } from "../../models/IMedia";

export enum CallActions {
  CALL_STATE_CHANGE = "CALL_STATE_CHANGE",
  CALL_ENDED = "CALL_ENDED",
  TICKET_CHANGE = "TICKET_CHANGE",
  TEST_DEVICE_PERMISSIONS_URL_CHANGE = "TEST_DEVICE_PERMISSIONS_URL_CHANGE",
  AGENT_VOLUME_CHANGE = "AGENT_VOLUME_CHANGE",
  AGENT_MUTED = "AGENT_MUTED",
  TRACK_KIND_STATE_CHANGE = "TRACK_KIND_STATE_CHANGE",
  SCREEN_SHARE_AVAILABILITY_CHANGE = "SCREEN_SHARE_AVAILABILITY_CHANGE",
  POPPED_OUT_CHANGE = "POPPED_OUT_CHANGE",
  MEDIA_AVAILABLE_CHANGE = "MEDIA_AVAILABLE_CHANGE",
}

export interface CallStateChange {
  type: CallActions.CALL_STATE_CHANGE;
  payload: CallStateEnum;
}
export interface TicketChange {
  type: CallActions.TICKET_CHANGE;
  payload: string;
}
export interface TestDevicePermissionsUrlChange {
  type: CallActions.TEST_DEVICE_PERMISSIONS_URL_CHANGE;
  payload: string;
}
export interface CallEnded {
  type: CallActions.CALL_ENDED;
}
export interface AgentMuted {
  type: CallActions.AGENT_MUTED;
  payload: boolean;
}
export interface AgentVolumeChange {
  type: CallActions.AGENT_VOLUME_CHANGE;
  payload: number;
}
export interface TrackKindStateChange {
  type: CallActions.TRACK_KIND_STATE_CHANGE;
  payload: { kind: "audio" | "video"; enabled: boolean };
}
export interface ScreenShareAvailabilityChange {
  type: CallActions.SCREEN_SHARE_AVAILABILITY_CHANGE;
  payload: boolean;
}
export interface CallPoppedOutChange {
  type: CallActions.POPPED_OUT_CHANGE;
  payload: boolean;
}
export interface MediaAvailableChange {
  type: CallActions.MEDIA_AVAILABLE_CHANGE;
  payload: IMedia;
}
export const dispatchCallStateChange =
  (payload: CallStateEnum) => (dispatch, _getState) => {
    return dispatch({
      type: CallActions.CALL_STATE_CHANGE,
      payload,
    } as CallStateChange);
  };
export const dispatchCallEnded = () => (dispatch, _getState) => {
  return dispatch({ type: CallActions.CALL_ENDED } as CallEnded);
};
export const dispatchTicketChange =
  (payload: string) => (dispatch, _getState) => {
    return dispatch({
      type: CallActions.TICKET_CHANGE,
      payload,
    } as TicketChange);
  };
export const dispatchTestDevicePermissionsUrlChange =
  (payload: string) => (dispatch, _getState) => {
    return dispatch({
      type: CallActions.TEST_DEVICE_PERMISSIONS_URL_CHANGE,
      payload,
    } as TestDevicePermissionsUrlChange);
  };
export const dispatchAgentVolumeChange =
  (payload: number) => (dispatch, _getState) => {
    return dispatch({
      type: CallActions.AGENT_VOLUME_CHANGE,
      payload,
    } as AgentVolumeChange);
  };
export const dispatchAgentMuted =
  (payload: boolean) => (dispatch, _getState) => {
    return dispatch({ type: CallActions.AGENT_MUTED, payload } as AgentMuted);
  };
export const dispatchTrackKindStateChange =
  (payload: { kind: "audio" | "video"; enabled: boolean }) =>
  (dispatch, _getState) => {
    return dispatch({
      type: CallActions.TRACK_KIND_STATE_CHANGE,
      payload,
    } as TrackKindStateChange);
  };
export const dispatchScreenShareAvailabilityChange =
  (payload: boolean) => (dispatch, _getState) => {
    return dispatch({
      type: CallActions.SCREEN_SHARE_AVAILABILITY_CHANGE,
      payload,
    } as ScreenShareAvailabilityChange);
  };
export const dispatchCallPoppedOutChange =
  (payload: boolean) => (dispatch, _getState) => {
    return dispatch({
      type: CallActions.POPPED_OUT_CHANGE,
      payload,
    } as CallPoppedOutChange);
  };
export const dispatchMediaAvailableChange =
  (payload: IMedia) => (dispatch, _getState) => {
    return dispatch({
      type: CallActions.MEDIA_AVAILABLE_CHANGE,
      payload,
    } as MediaAvailableChange);
  };
